<template>
    <div class="appointments-changing">
        <AppointmentsChooseDate :action="2"
                                :project-id="projectId"
                                :client-phone="clientPhone"
                                :client-name="clientName"
                                :client-surname="clientSurname"
                                :visit-record-id="visitRecordId"
                                :external-comment="externalComment"
                                @recordCreated="recordUpdated"
                                @recordNotCreated="recordNotUpdated"
                                @back="attemptToCancelRecord" />
    </div>
</template>

<script>
import AppointmentsChooseDate from '@/blocks/AppointmentsBlock/AppointmentsChooseDate/AppointmentsChooseDate';

export default {
    name: 'AppointmentsChanging',

    components: {
        AppointmentsChooseDate,
    },

    props: {
        visitRecordId  : [String],
        projectId      : [String],
        clientPhone    : [String],
        clientName     : [String],
        clientSurname  : [String],
        externalComment: [String]
    },

    methods: {
        attemptToCancelRecord() {
            this.$emit('cancel');
        },

        recordUpdated(recordData) {
            this.$emit('recordUpdated', recordData);
        },

        recordNotUpdated() {
            this.$emit('recordNotUpdated');
        }
    }
};
</script>

<style lang="scss">
@import "AppointmentsChanging";
</style>
